export const usePricingHighchartsOptions = (
  chartData: string[][] | number[][],
  containsData: boolean | undefined,
  rateTitle: string
): Highcharts.SeriesOptionsType[] => {
  const lightPurpleColor = "rgba(120, 111, 246, 0.3)"
  const darkPurpleColor = "#786FF6"
  const rateSeries: [number, number][] = []
  const treasurySeries: [number, number][] = []
  const treasurySeriesOptions: Highcharts.SeriesOptionsType = {
    name: "Treasury",
    data: [],
    type: "line",
    color: lightPurpleColor,
    showInLegend: true,
    lineWidth: 0,
    marker: {
      enabled: true,
      symbol: "square",
      radius: 7
    }
  }
  const rateSeriesOptions: Highcharts.SeriesOptionsType = {
    name: rateTitle,
    data: [],
    type: "line",
    color: darkPurpleColor,
    showInLegend: true,
    lineWidth: 0,
    marker: {
      enabled: true,
      symbol: "square",
      radius: 7
    }
  }

  if (!containsData) return [treasurySeriesOptions, rateSeriesOptions]

  const chartHeader = chartData[0] as string[]
  const chartRows = chartData!.slice(1)

  const dateIndex = chartHeader.indexOf("Date")
  const rateIndex = chartHeader.indexOf("Rate")
  const treasuryIndex = chartHeader.indexOf("Treasury")

  for (const chartRow of chartRows) {
    const date = chartRow[dateIndex] as number
    const rate = chartRow[rateIndex] as number | null
    const treasury = chartRow[treasuryIndex] as number | null

    if (rate !== null) {
      rateSeries.push([date, rate])
    }
    if (treasury !== null) {
      treasurySeries.push([date, treasury])
    }
  }

  return [
    {
      ...treasurySeriesOptions,
      data: treasurySeries,
      lineWidth: 1,
      marker: { enabled: false }
    },
    {
      ...rateSeriesOptions,
      data: rateSeries,
      lineWidth: 1,
      marker: { enabled: false }
    }
  ]
}
